import axios from "axios";
import { handleGetLocal } from "../../services/auth-service";
import { logOut } from "../../components/Logout";


export const getDateFormat = (navigate, setloading, setDateFormat) => {
  const pathname = handleGetLocal("pathURL");

  setloading(true);

  axios
    .get(
      `${process.env.REACT_APP_API_URL}/api/User/get-company-options?sName=${"Date Format"}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          Domain: `${pathname}`,
        },
      }
    )
    .then((res) => {
      setloading(false);

      if (res?.data?.data && res.data.data.length > 0) {
        const value = res.data.data[0].sValue;
        localStorage.setItem("dateFormat", value); 
        setDateFormat(value);
      } else {
        localStorage.setItem("dateFormat", "MM/DD/YYYY");
        setDateFormat("MM/DD/YYYY");
      }
    })
    .catch((err) => {
      setloading(false);

      if (!err?.response) {
        navigate(`/error/500`);
      } else if (err?.response?.status === 401) {
        logOut();
      }
      setDateFormat("MM/DD/YYYY");
    });
};